export default {
  methods: {
    $setBreadcrumbTitle(title, index = 1) {
      this.$route.meta.breadcrumbs[index].title = title;
    },
  },
};
